import React, { useMemo} from 'react';
import moment from "moment";
import { HiOutlinePencilAlt } from "react-icons/hi";
import { useGroupChatContext } from '../../context/groupchatContext';
import { titleWithoutUnderscore } from "../../helpers/utility";


const SelectedMessageSection = ({msg}) => {
    console.log("msg =. ", msg)
    const groupChatContext = useGroupChatContext();
    const {authData} = useMemo(() => ({
        authData: groupChatContext.authData,
    }));

    if  (msg.message.event_type == 'note_signed'){
        // Check if message contains zip file attachments
        const hasZipAttachment = msg.message.media?.some(file => file.mime_type === 'application/zip');
        
        return(
            <div className={`p-2 rounded-b-md text-start`}>
                <p className="mb-1">DOS: {moment(msg.message.data?.date_of_service).format('MM/DD/YYYY hh:mm A')}</p>
                {!hasZipAttachment && (
                    <p>Encounter number: {msg.message.data?.serial_number}</p>
                )}
            </div>
        );
        }
        else if(msg.message.event_type == 'request_appointment'){
            const isPendingAppointment = msg.message.data?.status?.toLowerCase() == 'pending'
            return(
                <div className={`text-gray-800 text-start`}>
                    <h1 className={`flex gap-2 justify-between capitalize font-bold border-b py-1 px-2 rounded-t-md`}>
                        {isPendingAppointment ? titleWithoutUnderscore(msg.message?.event_type) : 'Appointment'}
                        {(authData?.is_provider && isPendingAppointment) ? <HiOutlinePencilAlt title="Edit Appointment" className="mt-1 h-5 w-5 cursor-pointer" /> : null }
                    </h1>
                    <div className={`p-2 rounded-b-md`}>
                        <p><span className="font-semibold">Date:</span> {moment(msg.message.data?.start_date).format('MM/DD/YYYY hh:mm A')}</p>
                        <p><span className="font-semibold">Status:</span> {msg.message.data?.status}</p>
                    </div>
                </div>
            );
        }
        else if(msg.message.event_type == 'appointment'){
            return(
                <div className={`p-2 rounded-b-md text-start`}>
                    <p>On: {moment(msg.message.data?.start_time).format('MM/DD/YYYY hh:mm A')}</p>
                    <p>With: {msg.message.data?.provider_name}</p>
                </div>
            );
        }
        else if(msg.message?.event_type == 'vezo_session'){
            return(
                <div className={`p-2 rounded-b-md text-start`}>
                    <p>On: {moment(msg.message.data?.start_time).format('MM/DD/YYYY hh:mm A')}</p>
                    <p>With: {msg.message.data?.provider_name}</p>
                </div>
            );
        }
        else if(msg.message.event_type == 'referral_requested'){
            return(
                <div className={`p-2 rounded-b-md text-start`}>
                    <p className="mb-1">
                        <span className="font-medium">Urgency:</span> <span className="capitalize">{msg.message.data?.urgency}</span>
                    </p>
                    <p className="mb-1">
                        <span className="font-medium">Reason:</span> <span className="capitalize">{titleWithoutUnderscore(msg.message.data?.reason)}</span>
                    </p>
                    <p className="mb-1">
                        <span className="font-medium">Specialty:</span> <span className="capitalize">{titleWithoutUnderscore(msg.message.data?.specialty)}</span>
                    </p>
                </div>
            );
        }else{
            return null;
        }
};

export default SelectedMessageSection;